import { render } from "./Worksheets.vue?vue&type=template&id=00c27483"
import script from "./Worksheets.vue?vue&type=script&lang=js"
export * from "./Worksheets.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__